export function market(state = [], action) {
  if (action.type === 'GET_MARKET') {
    return action.stores;
  }

  return state;
}
